import React, { Component } from 'react';
import MalidCard from './MalidCard';

class MalfarView extends Component {
	cleanHtml(html) {
        if (!html) return '';
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        
        doc.querySelectorAll('[style]').forEach(el => el.removeAttribute('style'));
        
        return doc.body.innerHTML;
    }
	render() {
		return (
			<MalidCard title={window.l('malfar_title')}
				count={this.props.count}
				visible={(this.props.data && this.props.data.length > 0)}
				frontPage={this.props.frontPage}
				database="malfar"
				aboutText={window.l('malfar_about')}
				className="truncated">
				{
					this.props.data && this.props.data.map((item, index) => {
						return <React.Fragment key={index}>
							{
								index > 0 && <hr/>
							}
							{
								item.flokkur_nr === 57 &&
								<p className="card-text"><em>Úr pistlum Jóns G. Friðjónssonar</em></p>
							}
							{
								item.flokkur_nr === 60 &&
								<p className="card-text"><em>Úr Íslensku máli, þáttum Jóns G. Friðjónssonar</em></p>
							}
							<p className={'card-text'+(item.faersla.length > 1000 ? ' preview' : '')}><span dangerouslySetInnerHTML={{__html: this.cleanHtml(item.faersla)}} /></p>
							<p><a target='blank' className="text-light" href={'http://malfar.arnastofnun.is/grein/'+item.id}>Lesa grein í málfarsbanka</a></p>
						</React.Fragment>
					})
				}
			</MalidCard>
		);
	}
}

export default MalfarView;



// WEBPACK FOOTER //
// ./src/components/MalfarView.js